// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "449d6ec644089d2fc5f0bbb44608170c2e23dd9a/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};